export const stringToRegex = str => new RegExp(str, 'i');
export const camelToSnakeCase = (str, delimeter = '_') => str.replace(/[A-Z]/g, `${delimeter}$&`).toLowerCase();
export const objectToInlineStyles = (obj = {}) => (
    Object
        .keys(obj)
        .reduce((styles, key) => (
            styles + `${camelToSnakeCase(key, '-')}: ${obj[key]}; `
        ), '')
) 